<div class="ss-wrap" [class.ss-open]="open()">
  <button
    type="button"
    class="ss-trigger iskill-select"
    (click)="toggle()"
    [attr.aria-expanded]="open()"
    [attr.aria-haspopup]="'listbox'">
    <span class="ss-display" [class.ss-placeholder]="!value">{{ value || placeholder }}</span>
  </button>

  @if (open()) {
    <div class="ss-panel">
      <label class="ss-sr-only" [attr.for]="searchInputId">Filter {{ placeholder }}</label>
      <input
        #searchInput
        [id]="searchInputId"
        type="text"
        class="ss-search"
        placeholder="Type to search…"
        [ngModel]="query()"
        (ngModelChange)="query.set($event)"
        (keydown.enter)="pickFirst()"
        (keydown.escape)="close()"
        autocomplete="off" />

      <div class="ss-list">
        @if (pinnedFirst) {
          <button
            type="button"
            class="ss-option ss-option--pinned"
            [class.ss-option--active]="pinnedFirst === value"
            (click)="select(pinnedFirst)">
            {{ pinnedFirst }}
          </button>
        }

        <button
          type="button"
          class="ss-option ss-option--clear"
          (click)="select('')">
          {{ placeholder }}
        </button>

        <!-- track $index, not value: duplicate labels in the option list
             (e.g. two people with the same name) would collide as track
             keys and break list re-rendering — which silently kills the
             type-to-filter behaviour. -->
        @for (o of filtered(); track $index) {
          <button
            type="button"
            class="ss-option"
            [class.ss-option--active]="o === value"
            (click)="select(o)">
            {{ o }}
          </button>
        }

        @if (filtered().length === 0) {
          <div class="ss-empty">No matches</div>
        }
      </div>
    </div>
  }
</div>
